module.exports = __webpack_public_path__ + "media/shoot.11e5f155.wav";